module.exports = __webpack_public_path__ + "img/LIGHTING 2 GREEN.38d9714.svg";